export const EXCMREGIONUSERDATA_DELETE_RESET = 'EXCMREGIONUSERDATA_DELETE_RESET'
export const EXCMREGIONUSERDATA_DELETE_SET_ERROR = 'EXCMREGIONUSERDATA_DELETE_SET_ERROR'
export const EXCMREGIONUSERDATA_DELETE_SET_DELETED = 'EXCMREGIONUSERDATA_DELETE_SET_DELETED'
export const EXCMREGIONUSERDATA_DELETE_TOGGLE_LOADING = 'EXCMREGIONUSERDATA_DELETE_TOGGLE_LOADING'
